import React, { useRef, useState, useCallback } from 'react';
import { Rnd } from 'react-rnd';
import './AppWindow.css';

const AppWindow = React.memo(function AppWindow({
  id,
  title = '',
  children,
  style = {},
  zIndex = 100,
  onClose,
  onFocus,
  initialX = 10,
  initialY = 50,
  initialWidth = 375,
  initialHeight = 275,
}) {
  const rndRef = useRef();
  const [position, setPosition] = useState({ x: initialX, y: initialY });
  const [size, setSize] = useState({ width: initialWidth, height: initialHeight });

  const handleFocus = useCallback(() => onFocus(id), [onFocus, id]);
  const handleClose = useCallback(() => onClose(id), [onClose, id]);
  const handleDragStop = useCallback((e, d) => setPosition({ x: d.x, y: d.y }), []);
  const handleResizeStop = useCallback((e, dir, ref, delta, newPos) => {
    setSize({
      width: parseInt(ref.style.width, 10),
      height: parseInt(ref.style.height, 10)
    });
    setPosition(newPos);
  }, []);

  return (
    <Rnd
      ref={rndRef}
      position={position}
      size={size}
      onDragStop={handleDragStop}
      onResizeStop={handleResizeStop}
      bounds="parent"
      minWidth={100}
      minHeight={100}
      style={{ zIndex, ...style }}
      onMouseDown={handleFocus}
      enableResizing
      dragHandleClassName="window-titlebar"
    >
      <div className="app-window">
        <div className="window-titlebar no-select">
          <button
            className="close-button"
            onClick={handleClose}
            onTouchEnd={handleClose}
            aria-label="Close window"
          >
            <svg width="10" height="10" viewBox="0 0 10 10">
              <path d="M2,2 L8,8 M8,2 L2,8" stroke="#fff" strokeWidth="1" />
            </svg>
          </button>
          <span className="window-title">{title}</span>
        </div>
        <div className="window-content">
          {React.isValidElement(children)
            ? React.cloneElement(children, { onRequestClose: handleClose })
            : children}
        </div>
      </div>
    </Rnd>
  );
});

export default AppWindow;